import type { NftId } from "@anaconda/core/nft/types"
import type { Order } from "@rarible/api-client"
import { sonnerToast } from "@rarible_int/anaconda_ui_components"
import { useMolecule } from "bunshi/react"
import { useCallback, useMemo } from "react"
import { getTransactionErrorMessage } from "../events/transaction-event"
import { SolanaAcceptItemBidTransactionMoleculeReatom } from "./solana-accept-item-bid-molecule.reatom"

export function useSolanaAcceptItemBid() {
  const { acceptItemBidActionFactory } = useMolecule(
    SolanaAcceptItemBidTransactionMoleculeReatom,
  )
  const acceptItemBidAction = useMemo(
    () => acceptItemBidActionFactory(),
    [acceptItemBidActionFactory],
  )

  const mutate = useCallback(
    (params: { itemId: NftId; order: Order }) => {
      void (async () => {
        try {
          await acceptItemBidAction(params).catch(() => undefined)
        } catch (error) {
          sonnerToast.error(getTransactionErrorMessage(error))
        }
      })()
    },
    [acceptItemBidAction],
  )

  return {
    mutate,
    isPending: !!acceptItemBidAction.pending(),
  }
}
